import * as React from "react";
import { WizardCarPWAViewProps } from "./typings";
import { observer } from "mobx-react";
import { LobTitle } from "src/components/shared/LobTitle/LobTitle";
import {
  UitkExperimentalButtonTabs,
  UitkTab,
  UitkTabsType,
  UitkTabAnchorType,
} from "uitk-react-experimental-button-tabs";
import { CarsFormView } from "./components/CarsFormView";
import { GroundTransportPWAViewV2 } from "./components/GroundTransportPWAViewV2/GroundTransportPWAViewV2";
import { useLocalization } from "@shared-ui/localization-context";
import { locKeys } from "./components/l10n";
import { GroundTransportPWAView } from "./components/GtPWA/GtPWAView";
import { LobSubtitle } from "src/components/shared/LobSubtitle/LobSubtitle";

export const WizardCarPWAView: React.FunctionComponent<WizardCarPWAViewProps> = observer((props) => {
  const { formatText } = useLocalization();
  const {
    carWizardState,
    carWizardState: { config: carConfig },
    carWizardState: {
      config: { gtConfig: gtConfig },
    },
  } = props.wizardState;
  const { tabSelected, onAARPChange, isAARPChecked } = props;
  const includeGT = carConfig.includeGT;
  const { simplifiedGroundTransportationForm } = carConfig;
  const actionForm = tabSelected
    ? carConfig.isCarTrawler
      ? carConfig.form.action.replace("{locale}", props.context.locale.substr(0, 2))
      : carConfig.form.action
    : gtConfig.form.action;
  const currentTab = formatText(tabSelected ? locKeys.carTabTitle : locKeys.gtTabTitle);
  const setInputsRefs = (ref: React.RefObject<HTMLInputElement>, secondRef?: React.RefObject<HTMLInputElement>) => {
    carWizardState.wizardInputsArray.push(ref);
    if (secondRef) {
      carWizardState.wizardInputsArray.push(secondRef);
    }
  };

  const getLocError = (isLink: boolean) => {
    if (!isLink) {
      return carWizardState.moreThanOneError()
        ? carConfig.form.submitButton.locMultipleWarningsToken!
        : carConfig.form.submitButton.locWarningToken!;
    }

    return carWizardState.moreThanOneError()
      ? carConfig.form.submitButton.locMultipleWarningsLinkToken
      : carConfig.form.submitButton.locWarningLinkToken;
  };

  return (
    <form
      noValidate={true}
      action={actionForm}
      autoComplete="off"
      className="WizardCarPWA"
      id={carConfig.elementId}
      data-fm={props.flexComponent.fmId}
      data-fm-title-id={props.flexComponent.fmTitleId}
      data-testid="wizard"
      onSubmit={carWizardState.submit}
    >
      <LobTitle lobState={carWizardState} />
      <LobSubtitle lobState={carWizardState} />
      {includeGT ? (
        <>
          <UitkExperimentalButtonTabs
            className="all-t-margin-three"
            selectedTab={currentTab}
            tabsType={UitkTabsType.NATURAL}
            onTabSelect={props.onTabOptionSelected}
            tabAnchorType={UitkTabAnchorType.BUTTON}
          >
            <UitkTab name={formatText(locKeys.carTabTitle)} id="Rental-cars-transportation" targetURI="carsForm">
              {tabSelected && (
                <CarsFormView
                  setInputsRefs={setInputsRefs}
                  carWizardState={carWizardState}
                  carConfig={carConfig}
                  onDriverAgeInRange={props.onDriverAgeInRange}
                  onDifferentDropOffSelected={props.onDifferentDropOffSelected}
                  isDriverAgeInRange={props.isDriverAgeInRange}
                  isDiffDropOff={props.isDiffDropOff}
                  getLocError={getLocError}
                  onAARPChange={onAARPChange}
                  isAARPChecked={isAARPChecked}
                />
              )}
            </UitkTab>
            <UitkTab name={formatText(locKeys.gtTabTitle)} id="Airport-transportation" targetURI="gtForm">
              {!tabSelected &&
                (!simplifiedGroundTransportationForm ? (
                  <GroundTransportPWAView
                    setInputsRefs={setInputsRefs}
                    carWizardState={carWizardState}
                    setType={props.setType}
                    isSubLOBMenuOpen={props.isSubLOBMenuOpen}
                    onSubLOBMenuItemClick={props.onSubLOBMenuItemClick}
                    onSubLOBMenuTriggerClick={props.onSubLOBMenuTriggerClick}
                    toggleBookRoundtrip={props.toggleBookRoundtrip}
                    getLocError={getLocError}
                  />
                ) : (
                  <GroundTransportPWAViewV2
                    setInputsRefs={setInputsRefs}
                    carWizardState={carWizardState}
                    toggleBookRoundtrip={props.toggleBookRoundtrip}
                    getLocError={getLocError}
                  />
                ))}
            </UitkTab>
          </UitkExperimentalButtonTabs>
        </>
      ) : (
        <>
          <UitkExperimentalButtonTabs
            className="all-t-margin-three"
            selectedTab={currentTab}
            tabsType={UitkTabsType.NATURAL}
            onTabSelect={props.onTabOptionSelected}
            tabAnchorType={UitkTabAnchorType.BUTTON}
          >
            <UitkTab name={formatText(locKeys.carTabTitle)} id="Rental-cars-transportation" targetURI="carsForm">
              <CarsFormView
                setInputsRefs={setInputsRefs}
                carWizardState={carWizardState}
                carConfig={carConfig}
                onDriverAgeInRange={props.onDriverAgeInRange}
                onDifferentDropOffSelected={props.onDifferentDropOffSelected}
                isDriverAgeInRange={props.isDriverAgeInRange}
                isDiffDropOff={props.isDiffDropOff}
                getLocError={getLocError}
                onAARPChange={onAARPChange}
                isAARPChecked={isAARPChecked}
              />
            </UitkTab>
          </UitkExperimentalButtonTabs>
        </>
      )}
    </form>
  );
});

export default WizardCarPWAView;
